const debugModeValue = false;
const userCenterBaseUrl = 'https://dashboard.onon.cn'
const loginBaseUrl = 'https://user.onon.cn'
const globalConfig = {
    /** ---------------------
     *  ✅ 调试相关参数
     * ---------------------- */
    debugMode: debugModeValue, // 是否开启调试

    /** ---------------------
     *  ✅ 接口地址配置
     * ---------------------- */
    individualCenter: userCenterBaseUrl + '/IndividualCenter', //个人中心
    myTraffic: userCenterBaseUrl + '/my', //我的流量                
    orderManagement: userCenterBaseUrl + '/OrderManagement', //订单管理
    invoiceManagement: userCenterBaseUrl + '/InvoiceManagement', //发票管理
    vipService: userCenterBaseUrl + '/VipService',
    discount: userCenterBaseUrl + '/OrdinaryUser',
    personalCenterHref: 'https://user.onon.cn',

    loginBaseUrl: loginBaseUrl,
    loginURL: loginBaseUrl + '/authorize',
    loginGetTokenURL: loginBaseUrl + '/onon/openapi/auth/token',
    loginRedirectURL: 'https://tts.onon.cn',
    loginClientID: '1914241671462260737',
    loginClientSecret: 'd3d5bb712b0b4fddb19b656939d5d721',
    svId: '2',

    ttsApiBaseUrl: 'https://user.onon.cn', // 正式环境 https://user.onon.cn  https://tts.onon.cn
    ttsApiDevUrl: 'http://11.0.0.168:51064', // 开发调试地址
    // ttsApiDevUrl2: '/newapi', //https://user.onon.cn
    ttsApiDevUrl2: 'https://user.onon.cn', //https://user.onon.cn

    ttsApiDevUrl3: '/ttsdev',

    CodeApiBaseUrl: 'https://t.onon.cn',
    CodeApiDevUrl: '/code',

    /** ---------------------
     *  ✅ Onon APP
     * ---------------------- */
    OnonTechUrl: 'http://www.onon.cn',
    OnonMTUrl: 'http://mt.onon.cn/',
    OnonCodeConversionUrl: 'http://mt.onon.cn/codeconvert',
    OnonMongolianConversionUrl: 'http://mt.onon.cn/convert',
    OnonProofreadUrl: 'http://spell.onon.cn',
    OnonOCRUrl: 'http://ocr.onon.cn'
}

if (globalConfig.debugMode) {
    globalConfig.loginClientID = '1914241519099973633';
    globalConfig.loginClientSecret = 'f3a439a117bf4217930caa9f36e40d93';
    globalConfig.loginRedirectURL = 'http://localhost:8080';

    globalConfig.ttsApiBaseUrl = globalConfig.ttsApiDevUrl2;

    globalConfig.CodeApiBaseUrl = globalConfig.CodeApiDevUrl;
}

export default globalConfig;